import { ajaxHandler, toast, spinnerElem } from './utilities/utilities';
document.addEventListener('DOMContentLoaded', function () {

    /**
     * Download invoice
     * 
     * @since 1.7.0
     */
    const downloadBtn = document.querySelector('#products-download-invoice-btn');
    if (downloadBtn) {
        downloadBtn.addEventListener('click', function () {
            const invoiceId = downloadBtn.dataset.invoiceId;
            const content = document.querySelector('.products-invoice');

            // Add loading spinner.
            const spinner = document.createElement('span');
            spinner.classList.add('vendora-spinner-border', 'vendora-spinner-border-sm');
            downloadBtn.prepend(spinner);

            // Create a new <style> element and append it to the document's <head>
            const style = document.createElement('style');
            document.head.appendChild(style);
            style.sheet?.insertRule('body > div:last-child img { all: unset; }');

            html2canvas(content, { scale: 2 }).then((canvas) => {
                // Remove the temporary style element to clean up the DOM
                style.remove();

                // Get the image data from the canvas
                const imgData = canvas.toDataURL('image/jpeg');
                const a4Width = 595;
                const a4Height = 842;

                // Create a new jsPDF instance (use 'p' for portrait or 'l' for landscape)
                const pdf = new jspdf.jsPDF({
                    orientation: 'p',
                    unit: 'px',
                    format: [a4Width, a4Height]
                });

                // Calculate width and height to fit the PDF page
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = (a4Height * pdfWidth) / a4Width;

                pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);
                pdf.save(`invoice-${invoiceId}.pdf`);
                downloadBtn.removeChild(spinner);
            });
        });
    }
});
